<script setup>
import {computed, provide} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../../stores/partners/portalContentAndDesignStore";
import LandingResourceContentBlock from "../../../../Pub/includes/resources/landing-page/LandingResourceContentBlock.vue";
import LandingResourceImage from "../../../../Pub/includes/resources/landing-page/LandingResourceImage.vue";
import LandingResourceText from "../../../../Pub/includes/resources/landing-page/LandingResourceText.vue";
import LandingResourceCta from "../../../../Pub/includes/resources/landing-page/LandingResourceCta.vue";
import LandingResourceFaq from "../../../../Pub/includes/resources/landing-page/LandingResourceFaq.vue";
import LandingResourceLink from "../../../../Pub/includes/resources/landing-page/LandingResourceLink.vue";
import LandingResourceAvailableRewards from "../../../../Pub/includes/resources/landing-page/LandingResourceAvailableRewards.vue";
import LandingResourceEarningsCalculator from "../../../../Pub/includes/resources/landing-page/LandingResourceEarningsCalculator.vue";
import LandingResourceDivider from "../../../../Pub/includes/resources/landing-page/LandingResourceDivider.vue";
import LandingResourceHowItWorks from "../../../../Pub/includes/resources/landing-page/LandingResourceHowItWorks.vue";
import LandingResourceEmbed from "../../../../Pub/includes/resources/landing-page/LandingResourceEmbed.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const layoutPadding = computed(() => {
    return 'px-4 sm:px-8 lg:px-14';
});

const getComponentForResource = (resource) => {
    // available_rewards doesn't require contents to be present
    if (resource.type === 'available_rewards') {
        return LandingResourceAvailableRewards;
    }
    
    // earnings_calculator doesn't require contents to be present
    if (resource.type === 'earnings_calculator') {
        return LandingResourceEarningsCalculator;
    }

    // divider doesn't require contents
    if (resource.type === 'divider') {
        return LandingResourceDivider;
    }

    // how_it_works doesn't require contents (pre-filled)
    if (resource.type === 'how_it_works') {
        return LandingResourceHowItWorks;
    }

    // embed doesn't require contents
    if (resource.type === 'embed') {
        return LandingResourceEmbed;
    }
    
    if (!resource || !resource.contents || !resource.contents.length) return null;
    switch (resource.type) {
        case 'content_block':
            return LandingResourceContentBlock;
        case 'image':
            return LandingResourceImage;
        case 'text':
            return LandingResourceText;
        case 'cta':
            return LandingResourceCta;
        case 'faq':
            return LandingResourceFaq;
        case 'link':
            return LandingResourceLink;
        default:
            return null;
    }
};

// Computed properties for styling
const getTextColorClass = computed(() => {
    const textColor = portalContentAndDesignStore.portalLayoutSettings?.referral_portal_content_text_color || 'gray-800';
    return `text-${textColor}`;
});

provide('fileUrls', {
    upload: portalContentAndDesignStore.getFileResourcesUploadRoute,
    delete: portalContentAndDesignStore.getFileResourcesDeleteRoute,
});
</script>

<template>
    <div
        v-if="portalContentAndDesignStore.landingPageResources?.resources && portalContentAndDesignStore.landingPageResources.resources.length"
        :class="[
              'pt-8 lg:pt-12 pb-8 lg:pb-20 space-y-12 border-t',
              layoutPadding,
              getTextColorClass
            ]"
    >
        <component
            v-for="(resource, index) in portalContentAndDesignStore.landingPageResources.resources"
            :key="index"
            :is="getComponentForResource(resource)"
            :resource="resource"
        />
    </div>
</template>

<style scoped>
.partnero-page-content-section {
    /* Preserve any specific styling for content sections */
}
</style>
